import large_airport from './large_airport.geojson?url';
import medium_airport from './medium_airport.geojson?url';
import heliport from './heliport.geojson?url';
import closed from './closed.geojson?url';
import balloonport from './balloonport.geojson?url';
import seaplane_base from './seaplane_base.geojson?url';
import small_airport from './small_airport.geojson?url';

export default {
    large_airport: large_airport,
    medium_airport: medium_airport,
    heliport: heliport,
    closed: closed,
    balloonport: balloonport,
    seaplane_base: seaplane_base,
    small_airport: small_airport,
};
